function passThrough(requestOrResponse) {
    return requestOrResponse;
}
var ErrorManagerClass = (function () {
    function ErrorManagerClass() {
        var _this = this;
        this.use = function (handler) {
            _this._handlers.push(handler);
        };
        this.eject = function (handler) {
            _this._handlers = _this._handlers.filter(function (func) { return func !== handler; });
        };
        this.triggerError = function (error) {
            _this._handlers.forEach(function (handler) {
                try {
                    handler(error);
                }
                catch (e) {
                }
            });
        };
        this._triggerAxiosError = function (error) {
            _this.triggerError(error);
            return Promise.reject(error);
        };
        this.interceptAxios = function (axiosInstance) {
            axiosInstance.interceptors.request.use(passThrough, _this._triggerAxiosError);
            axiosInstance.interceptors.response.use(passThrough, _this._triggerAxiosError);
        };
        this._handlers = [];
    }
    return ErrorManagerClass;
}());
export { ErrorManagerClass };
export var errorManager = new ErrorManagerClass();
//# sourceMappingURL=error-manager.js.map